export default __webpack_public_path__ + "static/media/A0005.b4a997c9.png";